import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default function PrivatePath({ children }) {
  const token = useSelector((state) => state.loginData.user?.accessToken);
  return token ? children : <Navigate to="/" />;
}
